import React from "react"
import HeadlineWithFocus from "../components/HeadlineWithFocus"
import Helmet from "react-helmet"
import { FaPaperPlaneO, FaChevronDown, FaChevronUp } from 'react-icons/lib/fa'
import { OutboundLink } from 'gatsby-plugin-google-analytics'

export default () => (
  <div className="c-content-box">
    <Helmet title="At play" />

    <HeadlineWithFocus>
      Photos
    </HeadlineWithFocus>
    <p>
      For a short time a couple years ago I was involved in taking photos. 
    </p>
    <p>
      These are a part of the result of my short affair with photography 
      ...soon arriving &nbsp; <FaPaperPlaneO />
    </p>
    <p>
      For now you can find some in my&nbsp; 
      <OutboundLink 
        href="https://www.flickr.com/photos/jamesawford/"
        target="_blank" 
        rel="noopener noreferrer">Flickr stream</OutboundLink>.
    </p>
  </div>
)



// WEBPACK FOOTER //
// ./src/pages/photozone.jsx